
import axios from 'axios';
import Resource from './Resource';
import UserContract from '../contracts/User';

/**
 * User class
 * @class
 **/
class User extends Resource implements UserContract
{
    /**
     * Resource identifier
     * @type {String}
     **/
    static handle = 'user_id';

    /**
     * Default attributes
     * @type {Object}
     **/
    static attributes: UserContract = {
        user_id: undefined,
        fullname: undefined,
        email: undefined,
        password: undefined,
        password_confirmation: undefined,
        superuser: false,
    };

    /**
     * Resource attributes
     * @type {UserContract}
     **/
    attributes: UserContract;

    /**
     * Current attributes
     */
    readonly user_id: number;
    fullname: string;
    email: string;
    password: string;
    password_confirmation: string;
    superuser: boolean;


    /**
     * Get all users
     * @return {Promise<User[]>}
     */
    static all(): Promise<User[]>
    {
        return axios.get( '/api/users' )
            .then( response => response.data.map( attributes => new User( attributes, true ) ) );
    }


    /**
     * Get user by id
     * @param {Number} [id=null]
     * @return {Promise<User>}
     */
    static fetch( id: number = null ): Promise<User>
    {
        const endpoint = id === null ?
            '/api/user' : `/api/user/${ id }`;

        return axios.get( endpoint )
            .then( response => new User( response.data, true ) );
    }


    /**
     * Reset users password
     * @param {String} account
     * @return {Promise<>}
     */
    static reset( account: string )
    {
        return axios.post( '/api/user/reset', { account } );
    }


    /**
     * Save user
     * @return {Promise<User>}
     */
    save(): Promise<User>
    {
        const action = this.exists ? 'patch' : 'put',
            endpoint = this.exists ? `/api/user/${ this.user_id }` : '/api/user';

        this.saving = true;
        return axios[action]( endpoint, this.changes ).then( response => {
            this.sync( response.data );
            this.saving = false;

            return this as User;
        });
    }
}

Resource.register( User );

export default User;
